import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Compass, Eye, Trash2 } from 'lucide-react';
import SectionHeader from './SectionHeader';

const AssessmentsSection = ({ 
  assessments, 
  sectionOrder, 
  onMoveSectionUp, 
  onMoveSectionDown, 
  onDeleteAssessment,
  isVisible 
}) => {
  const navigate = useNavigate();

  if (!isVisible || assessments.length === 0) return null;

  const getAssessmentTitle = (type) => {
    switch(type) {
      case 'career-interests':
        return 'Career Interest Assessment';
      case 'work-style':
        return 'Work Style Assessment';
      case 'onet':
        return 'O*NET Career Assessment';
      default:
        return type;
    }
  };

  return (
    <div className="mb-8 sm:mb-12">
      <SectionHeader 
        title="Your Assessments" 
        sectionId="assessments"
        viewAllPath="/assessments"
        viewAllColor="pink"
        sectionOrder={sectionOrder}
        onMoveSectionUp={onMoveSectionUp}
        onMoveSectionDown={onMoveSectionDown}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {assessments.slice(0, 3).map((assessment) => (
          <div
            key={assessment.id}
            className="p-4 sm:p-6 bg-white rounded-xl sm:rounded-2xl border border-gray-200 hover:shadow-lg transition-shadow"
            data-testid={`assessment-card-${assessment.id}`}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-pink-600 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
              <Compass className="w-5 h-5 text-white" />
            </div>
            <h3 className="font-semibold text-sm sm:text-base mb-1 line-clamp-1">
              {getAssessmentTitle(assessment.assessment_type)}
            </h3>
            <p className="text-xs text-gray-500 mb-3 sm:mb-4">
              Completed {new Date(assessment.created_at).toLocaleDateString()}
            </p>
            <div className="flex flex-wrap gap-2">
              <Button
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/assessments/results/${assessment.id}`);
                }}
                variant="outline"
                className="border-pink-200 text-pink-600 hover:bg-pink-50 text-xs px-2 sm:px-3 min-h-[36px]"
                data-testid={`view-assessment-${assessment.id}`}
              >
                <Eye className="w-3 h-3 sm:mr-1" />
                <span className="hidden sm:inline">View</span>
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteAssessment(assessment.id);
                }}
                className="border-red-200 text-red-600 hover:bg-red-50 text-xs px-2 sm:px-3 min-h-[36px]"
                data-testid={`delete-assessment-${assessment.id}`}
              >
                <Trash2 className="w-3 h-3 sm:mr-1" />
                <span className="hidden sm:inline">Delete</span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentsSection;
